import { render, staticRenderFns } from "./BICOnusList.vue?vue&type=template&id=c3491966&scoped=true&"
import script from "./BICOnusList.vue?vue&type=script&lang=js&"
export * from "./BICOnusList.vue?vue&type=script&lang=js&"
import style0 from "./BICOnusList.vue?vue&type=style&index=0&id=c3491966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3491966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3491966')) {
      api.createRecord('c3491966', component.options)
    } else {
      api.reload('c3491966', component.options)
    }
    module.hot.accept("./BICOnusList.vue?vue&type=template&id=c3491966&scoped=true&", function () {
      api.rerender('c3491966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/biconus/BICOnusList.vue"
export default component.exports